module.exports = __webpack_public_path__ + "img/ms-outlook-logo.c74eb9f4.svg";